var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSurgical(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.463,
    height: 26.808,
    viewBox: "0 0 28.463 26.808",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#4b4495;}.b{fill:#48d1cc;}.c{fill:#b1b1f8;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1.177)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M34.906,3.086,22.759,21.318l-2.579.541L23.4,17.02a2.161,2.161,0,0,0,.213-1.985h0a2.149,2.149,0,0,1,.213-1.985l4.921-7.386a6.034,6.034,0,0,1,6.155-2.579Z",
    transform: "translate(-8.92 -2.978)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M34.679,12.13l-20.09,8.739L13.6,23.313l5.331-2.321a2.149,2.149,0,0,1,1.989.139h0a2.149,2.149,0,0,0,1.989.139l8.136-3.539a6.024,6.024,0,0,0,3.633-5.6Z",
    transform: "translate(-5.039 -7.487)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M20.324,51.778a3.694,3.694,0,1,1,5.126-1.025A3.7,3.7,0,0,1,20.324,51.778ZM23.6,46.866a2.212,2.212,0,1,0,.619,3.067A2.215,2.215,0,0,0,23.6,46.866Z",
    transform: "translate(-10.118 -25.59)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M3.22,22.439A3.694,3.694,0,1,1,1.309,27.3,3.7,3.7,0,0,1,3.22,22.439ZM3.811,23.8a2.213,2.213,0,1,0,2.908,1.148A2.219,2.219,0,0,0,3.811,23.8Z",
    transform: "translate(0.175 -12.826)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M34.275,29.264a.725.725,0,1,1-.205-1A.728.728,0,0,1,34.275,29.264Z",
    transform: "translate(-18.056 -16.404)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSurgical);
export default __webpack_public_path__ + "static/media/surgical.dd1f6782df6aa412dbf7249d6c2838e6.svg";
export { ForwardRef as ReactComponent };